import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconPlan(props: SvgIconProps) {
  return (
    <SVGIcon width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5 3H19V17H3C1.89543 17 1 16.1046 1 15V15C1 13.8954 1.89543 13 3 13H5V3Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M11 11H16V14H11V11Z" fill="currentColor" />
      <path d="M11 9H16" stroke="currentColor" strokeWidth="2" />
      <path
        d="M1 3C1 1.89543 1.89543 1 3 1H5V13H3C1.89543 13 1 13.8954 1 15V15V3Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SVGIcon>
  );
}
